import styled, { css } from 'styled-components'

export const activeStyles = css`
  &&& {
    ${({ theme }) => css`
      background-color: ${theme.colors.primaryTint[10]};
      color: ${theme.colors.primaryTint[100]};
    `}
  }
`

export const hoverStyles = css`
  ${({ theme }) => css`
    background-color: ${theme.colors.state.hover};
    color: ${theme.colors.foreground.secondary[1]};
  `}
`

export const disabledStyles = css`
  color: ${({ theme }) => theme.colors.state.disabled};
`

export const Text = styled.span`
  padding: 8px 12px;
  font-size: 0.8125rem;
  line-height: 1.5;
`

export const IconWrapper = styled.span`
  display: inline-block;
  padding: 4px 8px;
  line-height: 0;
`

export const Icon = styled.svg`
  width: 24px;
  height: 24px;
`

export const Wrapper = styled.span<{ $active?: boolean }>(
  ({ theme, $active }) => css`
    display: inline-flex;
    cursor: pointer;

    color: ${theme.colors.foreground.secondary[4]};
    border-radius: ${theme.radii.large};

    transition: background ${theme.transitions.duration[0]} ease-in-out,
      color ${theme.transitions.duration[0]} ease-in-out;

    ${$active && activeStyles}

    &.active {
      ${activeStyles}
    }

    &:hover {
      ${hoverStyles}
    }

    &:disabled {
      ${disabledStyles}
    }
  `
)
